// Sticky hint while Pflicht-Academy is open — App bleibt nutzbar (Visit-Tracking).
// Dezent: Fortschritt + nächster Schritt; Desktop-Widget ergänzt das im Dashboard.
import { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import { useAuth } from "../ui/AuthContext.jsx";
import { hasAcademyAccess } from "../../utils/academyAccess.js";
import { AcademyAPI } from "../../constants/academyApi.js";

export default function AcademyOnboardingBanner() {
  const { needAcademy, hasFeature } = useAuth();
  const loc = useLocation();
  const allowed = hasAcademyAccess(hasFeature);
  const [percent, setPercent] = useState(null);
  const [nextTitle, setNextTitle] = useState("");

  const load = useCallback(async () => {
    if (!needAcademy || !allowed) return;
    try {
      const data = await AcademyAPI.status();
      setPercent(Number(data?.percent ?? 0));
      const next = (data?.modules || [])
        .flatMap((m) => m.lessons || [])
        .find((l) => l.status !== "completed" || l.needs_replay);
      setNextTitle(next?.title || "");
    } catch {
      /* silent */
    }
  }, [needAcademy, allowed]);

  useEffect(() => {
    load();
  }, [load]);

  if (!needAcademy || !allowed) return null;
  if (loc.pathname === "/academy" || loc.pathname.startsWith("/academy/")) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-0 z-[80] border-t border-amber-500/35 bg-[#0b1220]/92 backdrop-blur-md px-3 py-2 sm:px-4 pb-[max(0.5rem,env(safe-area-inset-bottom))]"
    >
      <div className="mx-auto max-w-5xl flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 justify-between">
        <div className="min-w-0 flex items-start sm:items-center gap-2">
          <GraduationCap className="w-4 h-4 text-amber-400 shrink-0 mt-0.5 sm:mt-0" aria-hidden />
          <div className="min-w-0">
            <p className="text-sm text-white/90 truncate">
              Pflicht-Academy{percent != null ? ` · ${percent}%` : ""}
              {nextTitle ? ` · ${nextTitle}` : ""}
            </p>
            <p className="text-[11px] text-white/45 sm:hidden">
              Widget auf Desktop · hier Fortschritt
            </p>
          </div>
        </div>
        <Link
          to="/academy"
          className="inline-flex items-center justify-center min-h-[40px] px-3 rounded-lg bg-amber-500/90 text-[#0b1220] text-sm font-semibold hover:bg-amber-400 transition-colors shrink-0"
        >
          Weiter lernen
        </Link>
      </div>
    </div>
  );
}
